export const SET_STATUS = 'SET_STATUS';
export const SET_IS_WINDOW_OPEN = 'SET_IS_WINDOW_OPEN';
export const SET_ERROR = 'SET_ERROR';
export const SET_IS_LEGAL_ACCEPTED = 'SET_IS_LEGAL_ACCEPTED';
export const SET_DEVICE_TYPE = 'SET_DEVICE_TYPE';
export const SET_POSITION = 'SET_POSITION';
export const SET_IS_AGENTS_AVAILABLE = 'SET_IS_AGENTS_AVAILABLE';
export const SET_FLOATING_BUTTONS_HIDDEN = 'SET_FLOATING_BUTTONS_HIDDEN';
